<template>
  <div class="">
    <el-row
        :gutter="20"
        class="form-row">
      <ShippingEligibilityInfo
          ref="eligibility"
          title="Expedited shipping not available for:" />
    </el-row>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <label>Kustomer URL</label>
          <el-input
              v-model="request_misc.zendesk_id"
              placeholder="https://ring.kustomer.com/chat/id"
              name="kustomer_url" />
        </div>
      </el-col>
    </el-row>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col
          :span="12">
        <div class="grid-content bg-purple">
          <label>Order Number</label>
          <el-input
              v-model="request_misc.order_number"
              :disabled="orderNotRequired"
              placeholder="Order number"
              name="order_number" />
        </div>
      </el-col>
      <el-col
          v-if="!isRefundRequest"
          :span="12">
        <el-row :span="20">
          <el-col
              v-acl.show="{ permission: 'select-expedited', on: 'CustomerRequest' }"
              :span="8">
            <label>Expedited</label>
            <div
                class="el-input"
                style="padding: 7px 0px;">
              <el-tooltip
                  v-if="expeditedNotAvailable"
                  :content="expeditedNotAvailableMsg"
                  placement="top"
                  effect="light">
                <el-switch :disabled="expeditedNotAvailable" />
              </el-tooltip>
              <el-switch
                  v-else
                  v-model="request_misc.expedited" />
            </div>
          </el-col>
          <el-col
              v-if="!isOneOffRequest && !isPartsRequest && !!isReplacementRequest && !replacementProductIsStockA"
              v-acl.show="{ permission: 'select-stock-a', on: 'CustomerRequest' }"
              :span="8">
            <label>Stock A</label>
            <el-tooltip
                content="Force Stock A not available - First setup is more than 30 days old"
                placement="bottom"
                :disabled="!!isReplacementRequest && !firstSetupIsMoreThan30DaysOld">
              <div
                  class="el-input"
                  style="padding: 7px 0px;">
                <el-switch
                    v-model="request_misc.stock_a"
                    :disabled="!!isReplacementRequest && !!firstSetupIsMoreThan30DaysOld" />
              </div>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="center-buttons">
      <el-button
          plain
          @click="back(1)">
        Back
      </el-button>
      <el-button
          type="info"
          plain
          @click="reset()">
        Reset
      </el-button>
      <el-button
          type="primary"
          :disabled="!isValid"
          plain
          @click="next(3)">
        Next
      </el-button>
    </div>
  </div>
</template>

<script>
import { get, clone, compact } from "lodash";
import { createNamespacedHelpers as h } from "vuex";
import ShippingEligibilityInfo from "@/containers/CustomerRequest/CustomerRequestComponents/ShippingEligibilityInfo";

const { mapActions: requestActions, mapGetters: requestGetters } =
  h("db/requests");
const { mapGetters: sharedGetters, mapActions: sharedActions } = h("shared");

let textFor = {
  parts: "Expedited shipping not available for one or more of the chosen parts",
  product: "Expedited shipping not available for the chosen product",
};

export default {
  name: "CustomerRequestMiscStep",
  components: {
    ShippingEligibilityInfo,
  },
  props: {
    device: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      expeditedNotAvailable: false,
      expeditedNotAvailableMsg: "",
      request_misc: {
        zendesk_id: null,
        purchase_location: null,
        order_number: null,
        expedited: false,
        stock: "b",
        stock_a: false,
        receive_first: false,
        price: null,
      },
    };
  },
  computed: {
    ...sharedGetters(["reason"]),
    ...requestGetters(["requestInProgress"]),
    isPartsRequest() {
      return this.requestInProgress.general.type === "parts";
    },
    isOneOffRequest() {
      return this.requestInProgress.general.type === "one_off";
    },
    isReplacementRequest() {
      return this.requestInProgress.general.type === "replacement";
    },
    isRefundRequest() {
      return this.requestInProgress.general.type === "refund";
    },
    replacementProductIsStockA() {
      if (!this.isPartsRequest) {
        return this.requestInProgress.product.device_price.stock == "a";
      }
    },
    firstSetupIsMoreThan30DaysOld() {
      let firstSetupDate = new Date(this.device.created_at);
      let today = new Date();
      let msBetweenDates = Math.abs(firstSetupDate.getTime() - today.getTime());
      let inBetweenDays = msBetweenDates / (24 * 60 * 60 * 1000);
      if (inBetweenDays > 30) {
        return true;
      } else {
        return false;
      }
    },
    orderNotRequired() {
      let location = get(this.request_misc, "purchase_location", null);
      if (!location) return true;
      return !/ring.com/.test(
        this.request_misc.purchase_location.toLowerCase()
      );
    },
    isValid() {
      return (
        !!this.request_misc.zendesk_id &&
        (this.isOneOffRequest ||
          (!this.isOneOffRequest && this.orderNotRequired) ||
          (!this.isOneOffRequest &&
            this.request_misc.purchase_location == "ring.com" &&
            !!this.request_misc.order_number))
      );
    },
    partDescriptions() {
      return compact(this.partsRequested.map((part) => part.text));
    },
    partsRequested() {
      return get(this.requestInProgress, "reasons.reasons", []).map(
        (item) => this.reason(item.id) || {}
      );
    },
    devicesRequested() {
      return compact([
        get(this.requestInProgress, "product.new_device_kind", null),
      ]);
    },
  },
  watch: {
    ["request_misc.expedited"](expedited, previous) {
      // disable expedited switch is not enough
      if (expedited && expedited !== previous)
        this.expeditedShippingEligibility();
    },
    ["request_misc.stock_a"](stock_a) {
      this.request_misc.stock = stock_a ? "a" : "b";
    },
  },
  created() {
    this.parseDataFromStore();
  },
  methods: {
    expeditedShippingEligibility() {
      // region/location
      let { customer_country: country_code, customer_state: state_code } =
        this.requestInProgress.address;

      let request = {
        country_code,
        state_code,
        expedited: true,
      };

      this.expeditedNotAvailableMsg = "";
      if (this.isPartsRequest) {
        request.part_descriptions = this.partDescriptions;
        this.expeditedNotAvailableMsg = textFor.parts;
      } else {
        request.product_kinds = this.devicesRequested;
        this.expeditedNotAvailableMsg = textFor.product;
      }

      this.$refs.eligibility.evaluate(request).then((satisfied) => {
        if (satisfied) return;
        this.expeditedNotAvailable = true;
        this.$nextTick(() => (this.request_misc.expedited = false));
      });
    },
    ...requestActions(["setMiscInformation"]),
    parseDataFromStore() {
      this.request_misc.purchase_location = get(
        this.device,
        "profile.retailer.name"
      );
      if (Object.keys(this.requestInProgress.misc).length > 0) {
        this.request_misc = clone(this.requestInProgress.misc);
      }
    },
    next() {
      this.setMiscInformation(this.request_misc).then((response) => {
        this.$emit("next");
      });
    },
    reset() {
      this.setMiscInformation({}).then(() => {
        this.request_misc = {
          zendesk_id: null,
          purchase_location: null,
          order_number: null,
          expedited: false,
          stock: "b",
          stock_a: false,
          receive_first: false,
          price: null,
        };
      });
    },
    back() {
      this.$emit("back");
    },
    updateOrderNumber() {
      if (this.orderNotRequired) {
        this.request_misc.order_number = null;
      }
    },
  },
};
</script>

<style lang="css"></style>
